const { CrudModel } = require('./crud');

export class UnitModel extends CrudModel {
	constructor() {
		super('admin/unit', [
			{ key: "deletionReason", name: "Justificativa", kind: "select", options: [
				{ name: "Contrato encerrado", value: "Contrato encerrado" },
				{ name: "Cadastro incorreto", value: "Cadastro incorreto" },
				{ name: "Cadastro duplicado", value: "Cadastro duplicado" },
				{ name: "Outra (descrição abaixo)", value: "Outra (descrição abaixo)" },
			]},
		]);
	}	
}

export default new UnitModel();
